import React from "react";
import { useNavigate } from "react-router-dom";

export default function LiveRoom() {
  const navigate = useNavigate();
  React.useEffect(() => { navigate("/live", { replace: true }); }, [navigate]);
  return null;
}
